/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { CONSOLE_CAMPAIGN_ID } from '../util/constants';
import { ConsoleMessageData } from '../interfaces/internal-message-payload';

export function isConsoleMessage(data: unknown): data is ConsoleMessageData {
 // This message has a campaign ID, meaning it was sent using the Firebase Console.
 return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}
